import React from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";
import styles from "./CSS/ContentNotFound.module.css";

const ContentNotFound = ({ message = "Content Not Found", onRefresh }) => {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <AlertTriangle className={styles.icon} size={48} />
        <h2 className={styles.title}>{message}</h2>
        <p className={styles.description}>
          The content you're looking for could not be found. Please try refreshing the page.
        </p>
        <button className={styles.refreshButton} onClick={handleRefresh}>
          <RefreshCw className={styles.refreshIcon} size={16} />
          Refresh Page
        </button>
      </div>
    </div>
  );
};

export default ContentNotFound;